import { Service } from 'services/ApiService/RequestAccessProxy/RequestAccessProxyApiClient';

export const defaultSite: Service = {
  serviceKey: '__EMPTY_SGMARKETS__',
  ressourceId: '00000000-0000-0000-0000-000000000000',
  name: 'SG Markets',
  url: 'https://sgmarkets.com/',
  popsIdentifier: '',
  activateIAMAccessWidget: false,
};

export type OnBehalfOf = {
  isFetching: boolean;
  isInternal?: boolean;
};
